import PropTypes from 'prop-types';
import React from 'react';
import withAuth from 'util/hoc/with-auth';
import Notification, {
  NotificationTypes,
} from 'library/components/notification';
import { resolve } from 'library/helpers/path-resolver';

class InAppNotifications extends React.Component {
  _retry_timeout = 1;

  get retryTimeout() {
    this._retry_timeout = Math.min(
      60000,
      this._retry_timeout + this._retry_timeout
    );
    return this._retry_timeout;
  }

  set retryTimeout(value) {
    this._retry_timeout = value;
  }

  componentDidMount() {
    this.connect();
  }

  connect = () => {
    if (typeof __NOTIFICATIONS_URL__ !== 'undefined') {
      this.socket = new WebSocket(`wss://${__NOTIFICATIONS_URL__}`);
      this.socket.addEventListener('message', this.handleMessage);
      this.socket.addEventListener('error', this.reconnect);
      this.socket.addEventListener('open', this.handleOpen);
    }
  };

  handleOpen = () => {
    this.retryTimeout = 1;
  };

  reconnect = (e) => {
    console.error(e);

    try {
      if (this.socket) {
        this.socket.close();
      }
    } catch (e) {}

    setTimeout(this.connect, this.retryTimeout);
  };

  handleMessage = (e) => {
    const { message, duration = 5000, type = 'info' } = JSON.parse(e.data);

    const Component = resolve(NotificationTypes, type, NotificationTypes.info);

    Notification.new({ timeout: duration }, <Component>{message}</Component>);
  };

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close();
    }
  }

  render() {
    return null;
  }
}

const ShowInAppNotifications = ({ authentication }) =>
  authentication.authorized ? <InAppNotifications /> : null;

ShowInAppNotifications.propTypes = {
  authentication: PropTypes.object.isRequired,
};

export default withAuth(ShowInAppNotifications);
